export const getMainMenuStyles = (mainMenu, { palette = {} }) => ({
  mainMenuContainer: {
    transition: 'width 0.2s',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 1 1px',
  },
  hidden: {
    display: 'none',
  },
  menuList: {
    listStyle: 'none',
    paddingTop: 8,
    // borderTop: `solid 1px ${palette.neutralQuaternaryAlt}`,
  },
  divider: {
    borderTop: `solid 1px ${palette.mainMenuHoverBackground}`,
  },
  majorComponentsContainer: {
    borderTop: 'none',
  },
  connectionLoading: {
    flex: '1 1 1px',
    width: '100%',
    display: 'flex',
    transition: 'width 0.2s',
    padding: '10px 0px 0px 15px',
  },
});
